import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ICampaign, EmailPreference, CampaignStatus, campaignModel, ModalData } from '../../model/campaign';
import { MatPaginator as MatPaginator } from '@angular/material/paginator';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateCampaignModalComponent } from '../create-campaign-modal/create-campaign-modal.component';
import { Router } from '@angular/router';
import { CampaignService } from 'src/app/_services/campaign.service';
import { SharedService } from '../shared-service.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { HttpErrorResponse } from '@angular/common/http';
import { HireSearchService } from 'src/app/hire-person-search/services/hire-search.service';
import { EmailIntegrationService } from 'src/app/_services/email-integration.service';
import { campaignStagesPath, campaignTargetListingPath } from '../campaign-scope.util';

@Component({
    selector: 'app-email-campaign-create-campaign',
    templateUrl: './email-campaign-create-campaign.component.html',
    styleUrls: ['./email-campaign-create-campaign.component.scss'],
    standalone: false
})
export class EmailCampaignCreateCampaignComponent implements OnInit {
  projectNumber = this.resolveProjectNumberFromUrl();

  modalData: ModalData = {campaignName: ''};
  successMessage: string;
  errorMessage: string;

  scopeFilter: string = 'all';
  projectOptions: any[] = [];

  emailConnected: boolean | null = null;

  @ViewChild('renameCampaignModal') renameCampaignModal!: TemplateRef<any>;
  newCampaignName: string = '';
  renamingCampaign: campaignModel | null = null;

  constructor(private modalService: NgbModal, private router: Router, private emailCampaignService : CampaignService, private sharedService: SharedService, private localStorageService: LocalStorageService, private hireSearchService: HireSearchService, private emailIntegrationService: EmailIntegrationService){}

  private resolveProjectNumberFromUrl(): string | undefined {
    const segments = window.location.pathname.split('/').filter(Boolean);
    return segments[0] === 'projects' ? segments[1] : undefined;
  }

  // Sample data
  campaigns: campaignModel[] = [];
  displayCampaigns: campaignModel[];
  // MatTableDataSource to manage the table data
  dataSource = new MatTableDataSource<campaignModel >(this.campaigns);
  campaign_name: string = '';
  status: number | string;
  // MatPaginator for pagination
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  /**Used to check GetCampaigns api called or not */
  isCampaignsCalled: boolean = false;

  // Define the table columns
  displayedColumns: string[] = [
    'campaign_name',
    'status',
    'recipients',
    'contact_available',
    'opened',
    'replied',
    'actions',
    // 'bounced',
    // 'created_by',
    // 'created_on',
  ];

  // currentPage: number = 1;
  // itemsPerPage: number = 10;
  // totalPages: number;

  statuses = [
    {
      value: 1,
      status: "Active"
    },
    {
      value:2,
      status: "Paused"
    },
    {
      value: 3,
      status: "Draft"
    },
    {
      value: 5,
      status: 'Errored',
    }
  ]
  startIndex:  number = 0;
  endIndex: number = 10;
  currentPage: number = 1;
  pageSize: number = 10;
  totalPages: number = 0;
  totalCount: number = 0;
  userId: number = this.localStorageService.getItem('userdata').userid;
  mailboxConnected: boolean | null = null;
  showConnectForCreate = false;
  private resumeCreateAfterConnect = false;

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.checkEmailConnection();
    type k1 = keyof campaignModel;
  }

  private checkEmailConnection(): void {
    this.emailIntegrationService.fetchintegratedemails().subscribe({
      next: (res: any) => {
        this.mailboxConnected = !!(res?.integratedemailsarray && res.integratedemailsarray.length);
        this.applyConnectionState();
      },
      error: () => {
        // fail open rather than trapping the user behind a broken check - same as before this
        // check existed, when only the (bypassable) shell redirect gated the Global page.
        this.mailboxConnected = true;
        this.applyConnectionState();
      }
    });
  }

  private applyConnectionState(): void {
    if (this.projectNumber) {
      // Project context: visibility never depends on connection - always load the listing.
      this.emailConnected = true;
      this.loadCampaignListing();
    } else {
      // Global context: unchanged pre-existing behavior - the whole page is gated.
      this.emailConnected = this.mailboxConnected;
      if (this.emailConnected) {
        this.loadCampaignListing();
      }
    }
  }

  /** Called once we know a mailbox is connected - either already was, or just got connected via
   * the embedded app-email-campaign-connect's (connected) output. */
  onEmailConnected(): void {
    this.mailboxConnected = true;
    this.emailConnected = true;
    this.showConnectForCreate = false;
    if (this.resumeCreateAfterConnect) {
      this.resumeCreateAfterConnect = false;
      this.createCampaign();
    } else {
      this.loadCampaignListing();
    }
  }

  private loadCampaignListing(): void {
    // this.totalPages = Math.ceil(this.campaigns.length / this.itemsPerPage);
    // this.displayCampaigns = this.campaigns.slice(0, this.itemsPerPage);
    if (!this.projectNumber) {
      this.fetchProjectOptions();
    }
    this.getCampaigns(this.buildListPayload({page:0, limit: 10}));
  }

  private buildListPayload(base: Record<string, any> = {}): Record<string, any> {
    const payload: Record<string, any> = { ...base, created_by: this.userId };
    if (this.projectNumber) {
      payload['project_number'] = this.projectNumber;
    } else if (this.scopeFilter === 'global') {
      payload['scope'] = 'global';
    } else if (this.scopeFilter && this.scopeFilter !== 'all') {
      payload['project_id'] = this.scopeFilter;
    }
    return payload;
  }

  private fetchProjectOptions(): void {
    this.hireSearchService.getProjectTypeahead('').subscribe((response: any) => {
      if (response?.success) {
        this.projectOptions = response.data || [];
      }
    });
  }

  onScopeFilterChange(value: string): void {
    this.scopeFilter = value || 'all';
    this.currentPage = 1;
    this.getCampaigns(this.buildListPayload({ page: 0, limit: 10, ...(this.campaign_name && { campaign_name: this.campaign_name }), ...(this.status && this.status !== '0' && { status: this.status }) }));
  }
  // get startIndex(): number {
  //   return (this.currentPage - 1) * this.itemsPerPage;
  // }

  // get endIndex(): number {
  //   return this.startIndex + this.itemsPerPage;
  // }

  // get paginatedCampaigns(): campaignModel[] {
  //   return this.campaigns.slice(this.startIndex, this.endIndex);
  // }

  /**
   * Current time in milliseconds, used to determine if a campaign with an integration error is recoverable based on the time since the last error.
   */
  private nowInMilliseconds = new Date().getTime();

  /**
   * Checks if a campaign is recoverable based on its status and the time since the last integration error.
   * @param status
   * @param lastIntegrationErrorTime
   * @returns
   */
  isCampaignRecoverable(status: number, lastIntegrationErrorTime: string): boolean {
    if (status === 5 && lastIntegrationErrorTime) {
      const errorTime = new Date(lastIntegrationErrorTime).getTime();
      const sevenDaysSinceError = (this.nowInMilliseconds - errorTime) / (1000 * 60 * 60 * 24);
      return sevenDaysSinceError <= 7; // Campaign is recoverable if the last integration error occurred within the last 7 days
    }
    return false;
  }

  createCampaign(){
    if (this.projectNumber && !this.mailboxConnected) {
      this.resumeCreateAfterConnect = true;
      this.showConnectForCreate = true;
      return;
    }
    const modalRef = this.modalService.open(CreateCampaignModalComponent, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.modalData = this.modalData;
    modalRef.componentInstance.dataAdded.subscribe((data: ModalData) => {
      // Handle the data added from the modal
      const Campaign: any = {
        campaign_name: (data.campaignName).trim(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        schedule: "10:00-17:00",
        status: CampaignStatus.Draft,
        // TRMS-2857: the backend resolves this to the internal project_id and authorizes it
        // against the requester's accessible projects server-side (see campaignProjectAccess
        // middleware) - it never trusts this value alone.
        ...(this.projectNumber && { project_number: this.projectNumber })
      }
      // Call the emailCampaignService to create a new campaign based on data
      this.emailCampaignService.getCampaigns(this.buildListPayload({campaign_name: Campaign.campaign_name})).subscribe((res:any)=>{
        if(res?.data.length>0){
          const temp = res?.data.filter(x=> x.campaign_name===Campaign.campaign_name)
          if(temp && temp.length>0){
            modalRef.componentInstance.duplicateCampaignNameError = "Campaign name already exists";
          }
          else{
            this.emailCampaignService.createCampaign(Campaign).subscribe(
              (result:any) => {
                if(result.status=='success'){

                  modalRef.close();

                  this.router.navigate(campaignStagesPath(result['data'].campaign_id, this.projectNumber)) // TRMS-2857: project-scoped when embedded
                }
                else if(result.status=='failure'){
                  modalRef.close();
                  this.errorMessage = result && result.message? result.message : 'Something went wrong';
                  setTimeout(() => {
                    this.errorMessage = '';
                  }, 5000);
                }
              },
              (error) => {
                this.errorMessage = 'Something went wrong';
                  setTimeout(() => {
                    this.errorMessage = '';
                  }, 5000);
              }
            );
            // this.router.navigate(['/email-campaign/create-campaign-stages']); // Navigate to the campaign details page after data is added
          }
        }
        else{
            this.emailCampaignService.createCampaign(Campaign).subscribe(
              (result:any) => {
                if(result.status=='success'){

                  modalRef.close();

                  this.router.navigate(campaignStagesPath(result['data'].campaign_id, this.projectNumber)) // TRMS-2857: project-scoped when embedded
                }
                else if(result.status=='failure'){
                  modalRef.close();
                  this.errorMessage = result && result.message? result.message : 'Something went wrong';
                  setTimeout(() => {
                    this.errorMessage = '';
                  }, 5000);
                }
              },
              (error) => {
                this.errorMessage = 'Something went wrong';
                  setTimeout(() => {
                    this.errorMessage = '';
                  }, 5000);
              }
            );
            // this.router.navigate(['/email-campaign/create-campaign-stages']); // Navigate to the campaign details page after data is added
        }
      })

    });
  }
  getCampaigns(data: {}= { created_by: this.userId}) {
    // const tempData = this.campaigns;
    // this.displayCampaigns = tempData.slice(this.startIndex, this.endIndex);
    this.emailCampaignService.getCampaigns(data).subscribe(
      (data: any[]) => {
        this.campaigns = data['data'];
        if(this.campaigns && this.campaigns.length ==0){
          this.totalPages = 0;
          this.totalCount = 0;
          this.isCampaignsCalled = true; // lets the "Result Not Found!" empty state render below
          const isUnfiltered = !this.projectNumber && this.scopeFilter === 'all' && !this.status && !this.campaign_name;
          if (isUnfiltered) {
            this.router.navigate(['/email-campaign/dashboard']); // Navigate to the campaign details page after data is added
          }
          return;
        }
        // data['data'].map((x,i)=> {this.campaigns[i].name=x.campaign_name;
        // this.campaigns[i]['created_by']= x.created_by});
        this.totalPages = Math.ceil(data['total']/ this.pageSize);
        this.totalCount = data['total'];
        // if(this.totalCount==0)
        //   this.createCampaign()
        // this.totalCount = ???
        this.isCampaignsCalled = true
      },
      error => {
        console.error('Error getting campaigns:', error);
      }
    );
  }
  onPageChange(index: number) {
    // this.displayCampaigns = this.campaigns.slice((page - 1) * this.itemsPerPage, page * this.itemsPerPage);
    // this.currentPage = page;
    this.startIndex = (index - 1) * this.pageSize;
    this.endIndex = this.startIndex + this.pageSize;
    this.currentPage = index;
    if(this.status)
    this.getCampaigns(this.buildListPayload({page:this.currentPage-1, limit:10, status: this.status}));
    else
    this.getCampaigns(this.buildListPayload({page:this.currentPage-1, limit:10}));
  }
  getStatus(status: number){
    if(status === 1) return 'Active';
    if(status === 2) return 'Draft';
    if(status === 3) return 'Paused';
    if(status === 4) return 'Completed';
    if(status === 5) return 'IntegrationError';
    return 'Unknown';

  }
  filterCampaign(event, type){
    let payload = this.buildListPayload({page:0, limit: 10})
    if(type === 'input') {
      this.campaign_name = event || '';
    }
    else {
      this.status = event;
    }
    if(this.campaign_name.length)
      payload['campaign_name']=this.campaign_name;
    if(this.status && this.status!=='0'){
      this.currentPage  = 1;
      payload['status']=this.status;
    }
    this.emailCampaignService.getCampaigns(payload).subscribe(
      res=>{
        this.campaigns = res['data'];
        this.totalPages = Math.ceil(res['total']/ this.pageSize);
        this.totalCount = res['total'];
        // this.totalCount = ???
      }
    )
  }

  changeStatus(event: any, element: any){
    if (!element?.permissions?.canChangeStatus) return;
    this.emailCampaignService.getStages(element.campaign_id).subscribe(res=>{
      if(res && res['data'] && res['data'].length){
        this.emailCampaignService.updateCampaign( {status: event, campaign_id: element.campaign_id}).subscribe(res=>{
          this.getCampaigns(this.buildListPayload({page:0, limit: 10}));
          this.successMessage = 'Status updated';
          setTimeout(() => this.successMessage = '', 5000);
          const selectElement = document.getElementById('statusDropdown') as HTMLSelectElement;
          if (selectElement) {
            //@ts-ignore
            selectElement.value = 0;
          }
        }, (errorResp: HttpErrorResponse)=>{
          if (errorResp && errorResp.error) {
            // Backend now names the specific campaign/project already Active (TRMS-2857) - show
            // that verbatim instead of rebuilding a generic count-only message that hides which one it is.
            if (errorResp.error.message && Reflect.has(errorResp.error, 'currentActiveCampaigns')) {
              this.errorMessage = errorResp.error.message;
            } else {
              this.errorMessage = 'Failed to update status. Please try again.';
            }
          } else {
            this.errorMessage = 'Failed to update status. Please try again.';
          }
          setTimeout(() => this.errorMessage = '', 5000);
        })
      }
      else{
        this.errorMessage = 'Add stages before updateing status';
        setTimeout(() => this.errorMessage = '', 5000);
      }
        this.getCampaigns(this.buildListPayload({page:0, limit: 10}))
    })
  }
  redirectToListing(campaign_details){
    //redirect to email-campaign/target-listing
    this.emailCampaignService.getStages(campaign_details.campaign_id).subscribe(res=>{
      if(res && res['data'] && res['data'].length && campaign_details.status!==3)
        this.router.navigate(campaignTargetListingPath(campaign_details.campaign_id, this.projectNumber)); // TRMS-2857: project-scoped when embedded
      else
      this.router.navigate(campaignStagesPath(campaign_details.campaign_id, this.projectNumber)); // TRMS-2857: project-scoped when embedded
    })
  }

  openRenameModal(campaign: campaignModel) {
    if (!campaign?.permissions?.canEdit) return;
    this.renamingCampaign = campaign;
    this.newCampaignName = campaign.campaign_name;
    this.modalService.open(this.renameCampaignModal, { centered: true, backdrop: 'static', keyboard: false });
  }

  confirmRename() {
    const trimmed = this.newCampaignName.trim();
    const campaign = this.renamingCampaign;
    if (!trimmed || trimmed.length < 4 || !campaign?.permissions?.canEdit) return;

    this.emailCampaignService.getCampaigns(this.buildListPayload({ campaign_name: trimmed })).subscribe((res: any) => {
      const duplicate = res?.data?.some(
        (x: campaignModel) => x.campaign_name === trimmed && x.campaign_id !== campaign.campaign_id
      );
      if (duplicate) {
        this.errorMessage = 'Campaign name already exists';
        setTimeout(() => this.errorMessage = '', 5000);
        return;
      }

      this.emailCampaignService.updateCampaign({ campaign_id: campaign.campaign_id, campaign_name: trimmed }).subscribe(
        (result: any) => {
          this.modalService.dismissAll();
          this.renamingCampaign = null;
          this.newCampaignName = '';
          if (result?.status === 'success') {
            this.successMessage = 'Campaign renamed successfully';
            setTimeout(() => this.successMessage = '', 5000);
            this.getCampaigns(this.buildListPayload({ page: 0, limit: 10 }));
          } else {
            this.errorMessage = result?.message || 'Failed to rename campaign';
            setTimeout(() => this.errorMessage = '', 5000);
          }
        },
        () => {
          this.errorMessage = 'Failed to rename campaign. Please try again.';
          setTimeout(() => this.errorMessage = '', 5000);
        }
      );
    });
  }
}
